/* JC parallax for .hero--parallax sections (Sep 13).
   Sets --jc-parallax-y on each hero: up to +/-10% of the hero's height,
   driven by where the hero sits relative to the viewport centre.
   Desktop only, and disabled when the visitor prefers reduced motion. */
(function () {
  if (window.__jcParallax) return;
  window.__jcParallax = true;

  var mq = window.matchMedia('(min-width: 750px) and (prefers-reduced-motion: no-preference)');
  var heroes = [];
  var ticking = false;

  function strengthOf(h) {
    var v = parseFloat(h.getAttribute('data-parallax-strength'));
    return (isNaN(v) ? 15 : v) / 100;
  }

  function collect() {
    heroes = Array.prototype.slice.call(document.querySelectorAll('.hero--parallax'));
    heroes.forEach(function (h) {
      h.style.setProperty('--jc-parallax-scale', (1 + strengthOf(h) * 2).toFixed(3));
    });
  }

  function update() {
    ticking = false;
    if (!mq.matches) {
      heroes.forEach(function (h) { h.style.removeProperty('--jc-parallax-y'); });
      return;
    }
    var vh = window.innerHeight;
    heroes.forEach(function (h) {
      var r = h.getBoundingClientRect();
      if (r.bottom < 0 || r.top > vh) return;
      var centre = (r.top + r.bottom) / 2 - vh / 2;
      var range = vh / 2 + r.height / 2;
      var p = Math.max(-1, Math.min(1, centre / range));
      var shift = -p * r.height * strengthOf(h);
      h.style.setProperty('--jc-parallax-y', shift.toFixed(1) + 'px');
    });
  }

  function request() {
    if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
  }

  collect();
  update();
  window.addEventListener('scroll', request, { passive: true });
  window.addEventListener('resize', request);
  mq.addEventListener ? mq.addEventListener('change', request) : mq.addListener(request);
  document.addEventListener('shopify:section:load', function () { collect(); request(); });
  document.addEventListener('shopify:section:unload', function () { collect(); });
})();
